module.exports = {
    start_datetime: "",
    end_datetime: "",

    // Consultation close countdown. If set to true, show countdown in site header
    has_countdown: false,
    countdown_end: "00/00/0000 23:59:59", // Date format MM/DD/YYYY HH:MM:SS

    closed_message: "This consultation is closed and is no longer accepting feedback.",
    review_url: "/consultation/feedback-form/review/",
    success_url: "/consultation/feedback-form/success/",

    // This value needs to match the slug of the contact section. Determines which fields to show
    contact_slug: "your-details",

    sections: [

        {
            name: "About you",
            slug: "your-details",
            icon: "",
            colour: "primary",
            intro: "",
            questions: [
                {
                    label: "Title",
                    name: "title",
                    required: false,
                    type: "text",
                    placeholder: "Enter your title"
                },
                {
                    label: "First name",
                    name: "first_name",
                    required: true,
                    type: "text",
                    placeholder: "Enter your first name"
                },
                {
                    label: "Surname",
                    name: "last_name",
                    required: true,
                    type: "text",
                    placeholder: "Enter your surname"
                },
                {
                    label: "Address",
                    name: "address",
                    required: false,
                    type: "text",
                    placeholder: "Enter your address"
                },
                {
                    label: "Are you responding on behalf of an organisation?",
                    name: "organisation_confirm",
                    required: false,
                    type: "radio",
                    multiple: false, // Not required, for visual use only
                    options: [
                        {
                            label: "Yes",
                            value: "yes"
                        },
                        {
                            label: "No",
                            value: "no"
                        }
                    ],
                },
                {
                    label: "Name of organisation?",
                    name: "organisation",
                    required: false,
                    type: "text",
                    placeholder: "Enter name of organisation",
                },
                {
                    label: "Are you responding as a landowner? If so, please state your land parcel below.",
                    name: "landowner",
                    required: false,
                    type: "text",
                    placeholder: " ",

                },
                {
                    label: "If you would like to receive HCCP project updates, please tick yes and provide your email: ",
                    name: "progress",
                    required: false,
                    type: "radio",
                    options: [
                        {
                            label: "Yes",
                            value: "yes"
                        },
                        {
                            label: "No",
                            value: "no"
                        }
                    ]
                },
                {
                    label: "Email",
                    name: "email",
                    required: true,
                    type: "email",
                    placeholder: "Enter your email",
                },
                {
                    label: "Have you provided feedback previously on the main HCCP project?",
                    name: "previous_feedback",
                    required: false,
                    type: "radio",
                    multiple: false, // Not required, for visual use only
                    options: [
                        {
                            label: "Yes",
                            value: "yes"
                        },
                        {
                            label: "No",
                            value: "no"
                        }
                    ],
                }
            ]
        },
        {
            name: "Relevant planning application",
            slug: "page-2",
            icon: "",
            colour: "primary",
            intro: "",
            questions: [
                {
                    prefix: "1",
                    label: "Are you commenting on:",
                    name: "1-question",
                    required: false,
                    type: "radio",
                    multiple: false, // Not required, for visual use only
                    options: [
                        {
                            label: "The planning application for the south side, near East Halton and Goxhill (North Lincolnshire)",
                            value: "south-side"
                        },
                        {
                            label: "The planning application for the north side, near Paull and Thorngumbald (East Riding)",
                            value: "north-side"
                        },
                                                {
                            label: "Both",
                            value: "both"
                        }
                    ],
                },
            ]
        },
        {
            name: "Proposed works",
            slug: "page-3",
            icon: "",
            colour: "primary",
            intro: "",
            questions: [
                {
                    prefix: "2",
                    label: "Do you have any general comments on the proposed works for the trial HDD?",
                    sublabel: "",
                    number: "2",
                    name: "2-question",
                    type: "text"
                }
            ]
        },
        {
            name: "Construction traffic routes",
            slug: "page-4",
            icon: "",
            colour: "primary",
            intro: "",
          questions: [
                {
                    prefix: "3",
                    label: "Do you have any comments on the construction traffic routes proposed for the trial HDD?",
                    sublabel: "",
                    number: "3",
                    name: "3-question",
                    type: "text"
                }
            ]
        },
        {
            name: "Other Comments",
            slug: "page-5",
            icon: "",
            colour: "primary",
            intro: "",
            questions: [
                {
                    prefix: "4",
                    label: "Please note any other comments below that you would like us to consider.",
                    sublabel: "",
                    number: "4",
                    name: "4-question",
                    type: "text"
                }
            ]
        }
    ]
};
